import React, { useState } from 'react'
import DataTable from './DataTable';
import SectionCard from './SectionCard';
import { Grid } from '@mui/material';
import { insuranceTypeOptions, policyStatusOptions, providerOptions, statusOptions } from '.';
import CustomSelect from './CustomSelect';

const insurancedata = [
    {
        id: 1,
        sr: 1,
        product: "-",
        project: "-",
        projectStatus: "Construction yet to start",
        insuranceType: "CAR",
        policyStatus: "Active",
        insuranceProvider: "13.3%",
        coverageStartDate: "-",
        coverageEndDate: "-",
        underwritingCost: "-",
        actualCost: "-",
        policyLink: "-"
    },
    {
        id: 2,
        sr: 2,
        product: "-",
        project: "-",
        projectStatus: "Under construction, not operational",
        insuranceType: "FLOP",
        policyStatus: "Inactive",
        insuranceProvider: "13.3%",
        coverageStartDate: "-",
        coverageEndDate: "-",
        underwritingCost: "-",
        actualCost: "-",
        policyLink: "-"
    },
    {
        id: 3,
        sr: 3,
        product: "-",
        project: "-",
        projectStatus: "Under construction, partially operational",
        insuranceType: "-",
        policyStatus: "-",
        insuranceProvider: "13.3%",
        coverageStartDate: "-",
        coverageEndDate: "-",
        underwritingCost: "-",
        actualCost: "-",
        policyLink: "-"
    },
    {
        id: 4,
        sr: 4,
        product: "-",
        project: "-",
        projectStatus: "Completed",
        insuranceType: "-",
        policyStatus: "-",
        insuranceProvider: "13.3%",
        coverageStartDate: "-",
        coverageEndDate: "-",
        underwritingCost: "-",
        actualCost: "-",
        policyLink: "-"
    }
];

const InsuranceNew = () => {
    const columns = [
        { field: "sr", headerName: "#" },
        { field: "product", headerName: "Product" },
        { field: "project", headerName: "Project" },
        { field: "projectStatus", headerName: "Project status" },
        { field: "insuranceType", headerName: "Insurance type" },
        { field: "policyStatus", headerName: "Policy status" },
        { field: "insuranceProvider", headerName: "Insurance provider" },
        { field: "coverageStartDate", headerName: "Coverage start date" },
        { field: "coverageEndDate", headerName: "Coverage end date" },
        { field: "underwritingCost", headerName: "Underwriting cost" },
        { field: "actualCost", headerName: "Actual cost" },
        { field: "policyLink", headerName: "Policy link" }
    ];

    const [insuranceFilters, setInsuranceFilters] = useState({
        status: "",
        insuranceType: "",
        policyStatus: "",
        provider: "",
    });

    const handleInsuranceFilterChange = (field, value) => {
        setInsuranceFilters((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    return (
        <>
            <SectionCard title="Insurance" description="Policy Status, Coverage Tracking & Expiry Compliance Alerts">
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <CustomSelect
                            name="projectStatus"
                            options={statusOptions}
                            value={insuranceFilters.status}
                            onChange={(e) =>
                                handleInsuranceFilterChange("status", e.value)
                            }
                            placeholder="Project Status"
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <CustomSelect
                            name="insuranceType"
                            options={insuranceTypeOptions}
                            value={insuranceFilters.insuranceType}
                            onChange={(e) =>
                                handleInsuranceFilterChange("insuranceType", e.value)
                            }
                            placeholder="Insurance type"
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <CustomSelect
                            name="policyStatus"
                            options={policyStatusOptions}
                            value={insuranceFilters.policyStatus}
                            onChange={(e) =>
                                handleInsuranceFilterChange("policyStatus", e.value)
                            }
                            placeholder="Policy status"
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <CustomSelect
                            name="provider"
                            options={providerOptions}
                            value={insuranceFilters.provider}
                            onChange={(e) =>
                                handleInsuranceFilterChange("provider", e.value)
                            }
                            placeholder="Insurance Provider"
                        />
                    </Grid>
                </Grid>
            </SectionCard>
            <DataTable columns={columns} data={insurancedata} />
        </>
    );
}

export default InsuranceNew
